import { render, staticRenderFns } from "./ZhanhuiAreaYearStatBlock.vue?vue&type=template&id=e8704b9e&scoped=true"
import script from "./ZhanhuiAreaYearStatBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiAreaYearStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiAreaYearStatBlock.vue?vue&type=style&index=0&id=e8704b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8704b9e",
  null
  
)

export default component.exports